import { makeStyles } from '@mui/styles';

const useTitleHeaderContainerStyles = makeStyles({
	root: {
		backgroundColor: '#fafafa',
		position: 'relative',
		zIndex: 1000,
	},
	backButton: {
		backgroundColor: 'transparent',
		border: 0,
		cursor: 'pointer',
	},
	buttonRange: {
		borderRadius: '10px !important',
		background: '#0D66B6 !important',
		color: '#FFFFFF !important',
		fontSize: '12px !important',
		height: '38px',
		width: '160px',
		fontFamily: 'Montserrat !important',
		fontWeight: '600 !important',
		letterSpacing: '0px !important',
		marginRight: '70px !important',
	},
});

export default useTitleHeaderContainerStyles;
